import { SERVICES } from "../../data/home";
import type { Service } from "../../types";

export default function ServicesSection() {
  return (
    <section className="bg-ivory-2 py-24 px-5 lg:px-16" id="services">
      <div className="max-w-6xl mx-auto">
        {/* Header row */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div>
            {/* Section label strip */}
            <div className="flex items-center gap-3 mb-14">
              <span className="font-syne text-[10px] font-bold tracking-[0.28em] uppercase text-ink-20">What We Do</span>
              <span className="flex-1 h-px bg-ink-10" />
            </div>
            <h2
              className="font-syne font-extrabold text-ink tracking-tight leading-none"
              style={{ fontSize: 'clamp(2.5rem,4vw,4rem)' }}
            >
              Four Ways We{" "}
              <span className="text-violet">Show Up</span>
              <br />
              <em className="font-serif italic font-light text-ink-35" style={{ fontSize: '0.55em' }}>
                Every service built for maximum visual impact.
              </em>
            </h2>
          </div>
          <a
            href="#contact"
            className="font-syne text-[10px] font-semibold tracking-[0.14em] uppercase text-ink-55 border border-ink-20 px-5 py-2.5 rounded-sm hover:border-violet hover:text-violet transition-all self-end shrink-0"
          >
            View All Services →
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-ink-10 rounded-xl overflow-hidden">
          {SERVICES.map((service) => (
            <ServiceCard key={service.number} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service }: { service: Service }) {
  return (
    <div className="bg-white border-r border-ink-6 p-10 relative overflow-hidden cursor-pointer hover:bg-fog transition-colors group">
      {/* Top color bar */}
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-violet to-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

      <p className="font-syne font-extrabold text-[4.5rem] text-violet/10 group-hover:text-gold/30 leading-none mb-5 tracking-tight transition-colors">
        {service.number}
      </p>
      <h4 className="font-syne font-bold text-ink leading-tight mb-3">
        {service.title}
      </h4>
      <p className="text-[12.5px] text-ink-55 leading-[1.75] font-light">
        {service.description}
      </p>
      <p className="flex items-center gap-2 mt-5 font-syne text-[10.5px] font-semibold tracking-[0.1em] text-gold">
        <span className="w-3.5 h-px bg-gold/50" />
        {service.startingFrom}
      </p>
      {service.note && (
        <p className="mt-1.5 text-[10px] text-ink-35 font-light leading-snug">
          {service.note}
        </p>
      )}
    </div>
  );
}
